import api from "@/utils/axios";

export interface DocumentListDocument {
  id: number;
  signatura?: string;
  title?: string;
  fondo?: string;
  seccion?: string;
  added_at?: string;
}

export interface DocumentListItem {
  id: number;
  user_id: number;
  title: string;
  description?: string | null;
  is_archived: boolean;
  documents_count: number;
  created_at: string;
  updated_at: string;
  documents?: DocumentListDocument[];
  user?: {
    id: number;
    first_name?: string;
    last_name?: string;
    email?: string;
  };
}

export interface DocumentListListParams {
  page?: number;
  size?: number;
  user_id?: number | string;
  is_archived?: boolean | string;
  q?: string;
}

function unwrap<T>(res: { data: { status?: string; data?: T; message?: string } }): T {
  const body = res.data;
  if (body?.status === "success" && body.data !== undefined) {
    return body.data as T;
  }
  return body as unknown as T;
}

export const documentListsApi = {
  async list(params: DocumentListListParams = {}) {
    const res = await api.get("/document-lists", { params });
    return {
      data: (res.data?.data ?? []) as DocumentListItem[],
      meta: res.data?.meta ?? { total: 0, page: 1, size: 20 },
    };
  },

  async get(id: number | string): Promise<DocumentListItem> {
    const res = await api.get(`/document-lists/${id}`);
    return unwrap<DocumentListItem>(res);
  },

  async create(payload: { title: string; description?: string; user_id?: number }) {
    const res = await api.post("/document-lists", payload);
    return unwrap<{ id: number }>(res);
  },

  async update(
    id: number | string,
    payload: Partial<{ title: string; description: string | null; user_id: number }>
  ) {
    const res = await api.put(`/document-lists/${id}`, payload);
    return res.data;
  },

  async remove(id: number | string) {
    const res = await api.delete(`/document-lists/${id}`);
    return res.data;
  },

  async addDocuments(listId: number | string, documentIds: number[]) {
    const res = await api.post(`/document-lists/${listId}/documents`, {
      document_ids: documentIds,
    });
    return res.data as { status: string; added?: number; skipped?: number; message?: string };
  },

  /** @deprecated Usar addDocuments; mantiene compatibilidad con un solo ID */
  async addDocument(listId: number | string, documentId: number) {
    return this.addDocuments(listId, [documentId]);
  },

  async removeDocument(listId: number | string, documentId: number) {
    const res = await api.delete(`/document-lists/${listId}/documents/${documentId}`);
    return res.data;
  },

  async toggleArchive(id: number | string) {
    const res = await api.put(`/document-lists/${id}/archive`);
    return unwrap<{ is_archived: boolean }>(res);
  },
};
